import { render, staticRenderFns } from "./ImportTypeArticle.vue?vue&type=template&id=ace9235c&scoped=true"
import script from "./ImportTypeArticle.vue?vue&type=script&lang=js"
export * from "./ImportTypeArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace9235c",
  null
  
)

export default component.exports